import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class GuestGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router,
    ) { }

    canActivate(): boolean {
        if (this.authService.userLoggedIn()) {
            let userdetails = this.authService.getUserSessionDetails();
            switch (userdetails?.role) {
                case 'seller':
                case 'broker':
                    this.router.navigate(['/dashboard/seller/offer-sheet/generate']);
                    break;

                case 'buyer':
                    this.router.navigate(['/dashboard/buyer/offer-sheet/search']);
                    break;

                default:
                    this.router.navigate(['/dashboard']);
                    break;
            }

            return false;
        } else {
            return true;
        }
    }
}
